import MTooltip from './MTooltip';

export default MTooltip;
